/* * @Author: 孙福聪 * @Date: 2019-02-15 10:45:57 * @Last Modified by: 孙福聪 * @Last Modified time:
2019-02-26 13:09:24 */
<template lang="pug">
div.index-home(v-disabled="seeState")
    li.Guide-language
      div.title  案例阶段说明
      Input.guide-content(v-model="stageShow",
        type='textarea',
        :rows="3",
        :maxlength="150",
        :autosize="{maxRows: 3,minRows: 3}"
        ,placeholder="欢迎进入本案例实训！在此过程中，您将会在不同的场景中扮演不同角色，模拟完成一项公共政策从制定、执行、评估到终结的全过程。")
      div.surplus 剩余字数:{{stageShow ? 150-stageShow.length : 150}}
      //- div.guide-content 欢迎进入本案例实训！在此过程中，您将会在不同的场景中扮演不同角色，模拟完成一项公共政策从制定、执行、评估到终结的全过程。
    <!-- 首页大厅部分 !-->
    li.main-content
      div.title  首页大厅
      div.case-back
        img(src='../../assets/case/backrgound.png',
          style='margin-top: 0;margin-bottom: 0;').case-back
        div(v-for='(item,index) in hallList')
          div(:class='`hall${index}`' v-if="item.name != '会议室' && item.name != '现场调研'",).hallbackground
            span {{item.name === "" ? index+1: item.name}}
      div.title  编辑部门信息
      div.edit-department
        Row(:gutter="16")
          Col(span="8",v-for='(item,index) in hallList' :key="item.id",
            style='margin-top: 12px;' v-if="item.name != '会议室' && item.name != '现场调研'",)
            div(v-if="item.name !== '会议室' && item.name !== '现场调研' ")
              div(style='display: inline-block;width: 20px;') {{index > 3 ? index-1 : index + 1}}.
              input(v-model='item.name',placeholder='编辑部门名称',:maxlength="10",:readonly="index<3" @change="validateInput($event,item.name,index)").role-name
              Icon(type="ios-close-circle",v-if='index>2',color='red',size='22',
                @click='delDept(index)').icon
        Button(icon="md-add",
          style='color:#3A76D2;border: 1px solid #3A76D2;margin-top: 22px;',
          @click='add_department') 添加
        Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;;margin-left: 12px;margin-top: 22px;',
          @click='showAIDialog()',v-if='enableAI') AI生成
        Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
          Form(:model="aiForm" :label-width="80")
            FormItem(label="生成数量")
              InputNumber(v-model="aiForm.count" :min="1" :max="5" placeholder="请输入部门生成数量")
            FormItem(label='提示词',prop="stem")
              Input(v-model='aiForm.system' placeholder='请填写提示词'
                type="textarea" :rows="3")
      component(v-for='(item,index) in assemblyList',
        v-disabled="seeState"
        :key='index',
        :is='item.name',
        :data='item.data'
        :assemblyName='assemblyName',
        :ref="'indexhome'+index"
        :ha-id="haId"
        :task-id="taskId"
        :enableAI="enableAI"
        @upData="upData(index)",
        @downData="downData(index)"
        @data1:data ="val => item.data = val",
        @delModel='delModel(index)'
        @refresh-query="query"
      ).model
      div.drag(@drop="fun_drop",@dragover="allowDrop")
        p  把题型或者案例内容拖入此区域吧!
</template>
<script>
import MultipleA from "@/components/case/multiple";
import MultipleB from "@/components/case/multiple";
import Fillblank from "@/components/case/fillblank";
import TableQuestion from "@/components/case/tableQuestion";
import ligatureQuestion from "@/components/case/ligatureQuestion";
import DetermineQuestion from "@/components/case/determineQuestion";
import EasyQuestion from "@/components/case/easyQuestion";
import Material from "@/components/case/material";
import Matrix from "@/components/case/matrix";
import CaseAxis from "@/components/case/caseAxis";
import CaseTitle from "@/components/case/caseTitle";
import smallCaseTitle from "@/components/case/smallCaseTitle";
import CaseDialogue from "@/components/case/caseDialogue";
import CaseAskAndAnswer from "@/components/case/caseAskAndAnswer";
import CaseInfoBase from "@/components/case/caseInfoBase";
import CaseDepartment from "@/components/case/caseDepartment";
import CaseUpload from "@/components/case/caseUpload";
import CaseGuide from "@/components/case/caseGuide";
import CasePhotoText from "@/components/case/casePhotoText";
import CaseSingleText from "@/components/case/caseSingleText";
import CaseTitleText from "@/components/case/caseTitleText";
import CaseVideo from "@/components/case/caseVideo";
import MultipeChoice from "@/components/case/multipeChoice";
import Divider from "@/components/case/divider";
// 部门
import HALLBACKGROUND from "@/components/department/HallBackGround";
import LEADERSHIPOFFICE from "@/components/department/LeadershipOffice";
import MYOFFICE from "@/components/department/myOffice";
import POLLINGCENTER from "@/components/department/researchCenter";
import METTING from "@/components/department/scene";
import SURVEY from "@/components/department/survey";
import Unit from "@/components/department/unit";
import Single from "./single";
import mybus from "@/utils/main";
export default {
  inject: ["seeState"],
  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    TableQuestion,
    ligatureQuestion,
    DetermineQuestion,
    EasyQuestion,
    Material,
    Matrix,
    CaseAxis,
    CaseDialogue,
    CaseAskAndAnswer,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    CaseGuide,
    CasePhotoText,
    CaseSingleText,
    CaseTitleText,
    CaseVideo,
    CaseTitle,
    smallCaseTitle,
    MultipeChoice,
    Divider,
    LEADERSHIPOFFICE,
    MYOFFICE,
    POLLINGCENTER,
    SURVEY,
    METTING,
    UnitA: Unit, // 5
    UnitB: Unit, // 6
    UnitC: Unit, // 7
    UnitD: Unit, // 8
    UnitE: Unit, // 9
    UnitF: Unit, // 10
    UnitG: Unit, // 11
    UnitH: Unit, // 12
    UnitI: Unit, // 13
    UnitJ: Unit, // 14
    UnitK: Unit, // 15
    UnitL: Unit, // 16
    UnitM: Unit, // 17
    UnitN: Unit, // 18
    UnitO: Unit, // 19
    UnitP: Unit, // 20
    UnitQ: Unit, // 21
    HALLBACKGROUND,
  },
  props: ["assemblyName"],
  data() {
    return {
      assemblyList: [], // 拖进来的组件
      stageShow: "", // 步骤信息
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      hallList: [
        { name: "我的办公室", state: true },
        { name: "领导办公室", state: true },
        { name: "民意调查中心", state: true },
        { name: "会议室", state: true },
        { name: "现场调研", state: true },
      ], // 大厅的列表 12个大厅部门
      aiDialogVisible: false,
      aiForm: {},
      enableAI: false,
      haId: "",
      taskId: "",
    };
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    case() {
      console.log(
        'this.caseValue[+sessionStorage.getItem("CaseStage") - 1]',
        this.$store.state.Case.caseData
      );
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ];
    },
    hallData() {
      console.log(
        'this.caseValue[+sessionStorage.getItem("CaseStage") - 1]',
        this.$store.state.Case.caseData
      );
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].taskHome;
      // Or return basket.getters.fruitsCount
      // (depends on your design decisions).
    },
  },
  async mounted() {
    this.checkEnableAI();
    this.getNavList();
    // await this.$store.commit("getCaseData", this.Case.basic.id);
    const data = {
      chId: sessionStorage.getItem("chId"),
    };
    // console.log(+sessionStorage.getItem("CaseStage") - 1);
    const res = await this.$http.listCaseDepartmentStepByChid(data);
    const data2 = {
      index: this.caseValue[+sessionStorage.getItem("CaseStage") - 1],
      taskHome: res.data.data,
    };
    this.$store.commit("postcaseHome", data2);
    if (
      this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
        .taskHome.length !== 0
    ) {
      this.hallList = this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].taskHome.map((res2) => {
        return {
          name: res2.departmentName,
          id: res2.id,
        };
      });
    } else {
      this.hallList = [
        { name: "我的办公室", state: true },
        { name: "领导办公室", state: true },
        { name: "民意调查中心", state: true },
        { name: "会议室", state: true },
        { name: "现场调研", state: true },
      ];
    }

    console.log(
      this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
        .HallId
    );
    this.query();
  },
  watch: {
    hallData() {
      console.log("{isChange}");
      console.log(
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .taskHome
      );
      if (
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .taskHome.length !== 0
      ) {
        console.log(
          this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
            .taskHome
        );
        this.hallList = this.$store.state.Case.caseData[
          this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
        ].taskHome.map((res) => {
          return {
            name: res.departmentName,
            id: res.id,
          };
        });
      } else {
        this.hallList = [
          { name: "我的办公室", state: true },
          { name: "领导办公室", state: true },
          { name: "民意调查中心", state: true },
          { name: "会议室", state: true },
          { name: "现场调研", state: true },
        ];
      }
    },
  },
  created() {
    mybus.$on("updateHallList", (data) => {
      this.hallList = data;
    });
  },
  methods: {
    checkEnableAI() {
      this.$http
        .getEnableState()
        .then((res) => {
          if (res.data.success) {
            this.enableAI = res.data.data;
          } else {
            this.enableAI = false;
          }
        })
        .catch(() => {
          this.enableAI = false;
        });
    },
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    async generateCase() {
      const data = {
        inputs: {
          opt_type: "gen_dept",
          gen_dept_count: this.aiForm.count,
          system: this.aiForm.system,
          pyId: this.$store.state.Case.basic.id,
          gen_dept_chId: sessionStorage.getItem("chId"),
        },
      };

      const res = await this.$http.generateCase(data);
      if (res.data.success) {
        this.$Message.success("保存成功");
        const res2 = await this.$http.listCaseDepartmentStepByChid({
          chId: sessionStorage.getItem("chId"),
        });

        const stageIndex = this.caseValue[+sessionStorage.getItem("CaseStage") - 1];
        this.$store.commit("postcaseHome", {
          index: stageIndex,
          taskHome: Array.isArray(res2.data.data) ? res2.data.data : [],
        });
        this.hallList = Array.isArray(res2.data.data)
          ? res2.data.data.map((item) => ({
              name: item.departmentName,
              id: item.id,
            }))
          : [];
      }
    },

    async getNavList() {
      try {
        const { data } = await this.$http.getCaseHallNavbarList(this.$store.state.Case.basic.id);
        // this.caseValue = data.data.map(v => v.caseStep);
        this.stageShow = data.data.sort((a, b) => a.sortNo - b.sortNo)[
          +sessionStorage.getItem("CaseStage") - 1
        ].stageShow;
        this.haId = data.data.sort((a, b) => a.sortNo - b.sortNo)[
          +sessionStorage.getItem("CaseStage") - 1
        ].id;
      } catch (error) {
        console.log(error);
      }
    },
    upData(index) {
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦!");
      }
      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index],
      ];
      this.$forceUpdate();
    },
    downData(index) {
      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦!");
      }
      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index],
      ];
      this.$forceUpdate();
    },
    query(taskId = undefined) {
      const tsId2 =
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .HallId ||
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]]
          .id;
      this.taskId = tsId2;
      const data = {
        tsId: tsId2,
        module: this.$store.state.task.modules,
      };
      console.log("vvvvvv");
      console.log(this.taskId);
      // console.log(data);
      // console.log(this);
      console.log(taskId, "taskIdtaskIdtaskId");
      console.log(
        this.$store.state.Case.caseData[this.caseValue[+sessionStorage.getItem("CaseStage") - 1]],
        "执行ts"
      );
      this.$http.listControlByTsid(data).then(async (res) => {
        const { data: infoData } = await this.$http.listMaterials(
          taskId ||
            this.$store.state.Case.caseData[
              this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
            ].HallId ||
            this.$store.state.Case.caseData[
              this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
            ].id
        );
        console.log("执行了query");
        // let i;
        // let obj;
        // console.log(res.data.data.concat(infoData.data));
        // console.log(res.data.data);
        // this.ObtainSubject(res.data.data);
        this.ObtainSubject(res.data.data.concat(infoData.data));
      });
    },
    add_department() {
      console.log("this.hallList", this.hallList);
      // 添加部门
      // 多了办公室和现场调研
      if (this.hallList.length < 12) {
        this.hallList.push({ name: "部门", state: true });
      } else {
        console.log("this.hallList", this.hallList);
        this.$Message.error("最多添加10个部门");
      }
    },
    validateInput(e, item2, index) {
      console.log("🚀 ~ validateInput ~ e:", e.target.value, e.value === "现场调研", item2);
      const v = e.target.value;
      const arr = ["现场调研", "会议室", "我的办公室", "领导办公室", "民意调查中心"];
      if (
        arr.some((item3) => {
          return item3 === v;
        })
      ) {
        this.$Message.error("请勿重复添加相同的部门！");
        this.hallList[index].name = "部门";
      } else {
        item2 = e.value;
      }
    },
    fun_drop() {
      console.log("🚀 ~ fun_drop ~ this.assemblyName:", this.assemblyName);
      if (
        this.assemblyName !== "" &&
        this.assemblyName !== "LEADERSHIPOFFICE" &&
        this.assemblyName !== "MYOFFICE" &&
        this.assemblyName !== "POLLINGCENTER" &&
        this.assemblyName !== "UnitA" &&
        this.assemblyName !== "UnitB" &&
        this.assemblyName !== "UnitC" &&
        this.assemblyName !== "UnitD" &&
        this.assemblyName !== "UnitE" &&
        this.assemblyName !== "UnitF" &&
        this.assemblyName !== "SURVEY" &&
        this.assemblyName !== "METTING"
      ) {
        //
        this.assemblyList.push({ name: this.assemblyName, data: {} });
        console.log(this.assemblyName, "this.assemblyName");
      } else {
        this.$Message.error("请到任务下添加场景");
      }
    },
    allowDrop(e) {
      e.preventDefault();
    },
    delModel(value) {
      // 删除模块
      console.log(value);
      console.log("assemblyList", this.assemblyList);
      if (!this.assemblyList[value].data || !this.assemblyList[value].data.id) {
        this.assemblyList.splice(value, 1);
        return;
      }
      if (this.assemblyList[value].data.id) {
        this.$emit("delModel", this.assemblyList[value].data.id);
      }
      this.$store.commit("deleteControl", this.assemblyList[value].data.id);
      this.assemblyList.splice(value, 1);
      this.$forceUpdate();
    },
    delDept(index) {
      this.$Modal.confirm({
        title: `系统提示`,
        content: "<p>你确定要删除此数据吗?</p>",
        onOk: async () => {
          // this.handlesocredata();
          if (this.hallList[index].id) {
            // 删除部门
            await this.$http.batchDeletingCaseDepartmentStep({
              ids: JSON.stringify([this.hallList[index].id]),
            });
          }
          this.$Message.success("删除成功");
          this.hallList.splice(index, 1);
        },
      });
    },
  },
};
</script>
<style lang="stylus" socped>
.index-home
  .ivu-input, .guide-content
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 22px
    margin -10px 8px
  .drag
    max-width 1000px
    min-width 790px
    height 100px
    background #fff
    border-radius 4px
    border 1px dashed rgba(128, 128, 128, 0.5)
    margin-top 24px
    cursor alias
    p
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 100px
      text-align center
  .model
    border-bottom 1px solid #dddddd
    .Guide-language
      height 152px
      background rgba(255, 255, 255, 1)
      border-radius 4px
      padding 24px 32px
      min-width 854px
      max-width 1000px
      position: relative;
      .guide-content
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.75)
        line-height 22px
        margin 22px 8px
      .surplus
          position: absolute;
          right: 25px;
          bottom: 20px;
    .title
      font-size 14px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 0.8)
      line-height 18px
    .main-content
      padding 24px 32px 60px 32px
      height auto
      background rgba(255, 255, 255, 1)
      box-shadow 0px 2px 6px 0px rgba(0, 0, 0, 0.2)
      border-radius 4px
      margin-top 16px
      min-width 854px
      max-width 1000px
      .edit-department
        margin-top 30px
        padding 24px
        border-bottom 1px solid #dddddd
        .icon
          cursor pointer
        .role-name
          margin-left 8px
          padding 5px
          border none
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.75)
          line-height 18px
      .case-back
        width 100%
        height 100%
        margin-top 22px
        margin-bottom 22px
        position relative
      .hallbackground
        height 35px
        position absolute
        background rgba(32, 120, 223, 1)
        box-shadow 0px 1px 6px 0px rgba(0, 0, 0, 0.23)
        border-radius 4px 4px 4px 0px
        min-width 35px
        border 1px solid rgba(255, 255, 255, 1)
        font-size 16px
        font-family MicrosoftYaHeiUI
        color rgba(255, 255, 255, 1)
        padding 6px
        cursor pointer
        text-align center
      .hall0
        left 50%
        top 51%
      .hall1
        left 62%
        top 26%
      .hall2
        left 12%
        top 33%
      .hall3
        left 61%
        top 62%
      .hall4
        left 48%
        top 17%
      .hall5
        left 24%
        top 48%
      .hall6
        left 12%
        top 66%
      .hall7
        left 31%
        top 17%
      .hall8
        left 75%
        top 63%
      .hall9
        left 43%
        top 69%
      .hall10
        left 39%
        top 29%
      .hall11
        left 89%
        top 44%
</style>
